import script from "./UserSettingMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSettingMenu.vue?vue&type=script&setup=true&lang=js"

import "./UserSettingMenu.vue?vue&type=style&index=0&id=20752605&lang=scss"

const __exports__ = script;

export default __exports__